import React, { useEffect, useState } from "react";
import { Card, Pagination, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SideMenu from "../Components/SideMenu";
import NavbarWithDrawer from "../ComponentsWeb/Sub/NavbarWithDrawer";
import Footer from "../ComponentsWeb/Sub/Footer";
import { getNotifications } from "../reducers/commonReducer";
import { useLocation, useNavigate } from "react-router-dom";

const getNotificationTitle = (item) => {
  if (item?.chatGroup) {
    return item?.groupName
      ? `${item?.senderDisplayName} in ${item?.groupName}`
      : `${item?.senderDisplayName} sent a group message`;
  }

  return `${item?.senderDisplayName} sent a message`;
};

const getNotificationPreview = (item) => {
  if (item?.content) {
    return item.content;
  }

  switch (item?.messageType) {
    case "image":
      return "Sent an image";
    case "sticker":
      return "Sent a sticker";
    case "video":
      return "Sent a video";
    case "audio":
      return "Sent an audio message";
    case "file":
      return "Sent a file";
    default:
      return "New message";
  }
};

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const [page, setPage] = useState(Number(queryParameters.get("page")) || 1);
  const [loading, setLoading] = useState(true);
  const userSlug = localStorage.getItem("slug");
  const isAdminLayout = userSlug === "admin";

  const { notificationsData = [], notificationsTotalPage = 0 } = useSelector(
    (state) => state.commonReducer
  );

  useEffect(() => {
    setLoading(true);
    dispatch(getNotifications({ page })).finally(() => setLoading(false));
  }, [dispatch, page]);

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
    navigate(`/notifications?page=${nextPage}`);
    window.scrollTo(0, 0);
  };

  const content = (
    <div className={isAdminLayout ? "mt-extra content container-fluid" : "container-fluid"}>
      <div className={isAdminLayout ? "p-3 min-vh-100" : "p-5 mt-5 mb-5 mbl-pedding-10 min-vh-100"}>
        <div className="mb-3">
          <h3 className="mb-1">Notifications</h3>
          <p className="text-muted mb-0">
            Latest notifications in descending order, 20 per page.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        ) : notificationsData.length > 0 ? (
          <>
            {notificationsData.map((item) => (
              <Card key={item?.id} className="mb-3 shadow-sm border-0">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start gap-3">
                    <div>
                      <h6 className="mb-1">{getNotificationTitle(item)}</h6>
                      <p className="mb-1 text-muted">{getNotificationPreview(item)}</p>
                    </div>
                    <small className="text-muted">
                      {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                    </small>
                  </div>
                </Card.Body>
              </Card>
            ))}

            {notificationsTotalPage > 1 && (
              <Pagination className="justify-content-center mt-4">
                <Pagination.Prev
                  disabled={page <= 1}
                  onClick={() => handlePageChange(page - 1)}
                />
                {Array.from({ length: notificationsTotalPage }, (_, index) => index + 1).map(
                  (pageNumber) => (
                    <Pagination.Item
                      key={pageNumber}
                      active={pageNumber === page}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </Pagination.Item>
                  )
                )}
                <Pagination.Next
                  disabled={page >= notificationsTotalPage}
                  onClick={() => handlePageChange(page + 1)}
                />
              </Pagination>
            )}
          </>
        ) : (
          <div className="text-center py-5 text-muted">
            No notifications found.
          </div>
        )}
      </div>
    </div>
  );

  if (isAdminLayout) {
    return (
      <>
        <SideMenu />
        {content}
      </>
    );
  }

  return (
    <>
      <NavbarWithDrawer />
      {content}
      <Footer />
    </>
  );
};

export default Notifications;
